import { render, staticRenderFns } from "./ListCompliment.vue?vue&type=template&id=e5635e04"
import script from "./ListCompliment.vue?vue&type=script&lang=js"
export * from "./ListCompliment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports